export default function UpdatesBanner() {
  return null;
}
